<ninety-clock-timer [totalSeconds]="duration"></ninety-clock-timer>
